import { useEffect } from "react";
import reportWebVitals from "@/reportWebVitals";

export function ClientTelemetry() {
	useEffect(() => {
		if (import.meta.env.DEV) {
			void import("react-scan").then(({ scan }) => {
				scan({ enabled: true });
			});
		}
		reportWebVitals();
	}, []);

	return null;
}
